import { useId } from 'react';
import Select from 'react-select';
import { Option, MultiValueRemove, MenuList, DropdownIndicator } from './selectComponents';
import { useMultiSelectValue } from './hooks';
import * as styles from './index.module.css';

export function SelectMulti({
  options = [],
  value = [],
  onChange,
  placeholder = 'Select...',
  isDisabled = false,
  isLoading = false,
  closeMenuOnSelect = false,
  hideSelectedOptions = false,
  noOptionsMessage = () => 'No options available',
}) {
  const instanceId = useId();
  const { selectedOptions, handleChange } = useMultiSelectValue(options, value, onChange);

  return (
    <div className={styles['select-multi']}>
      <Select
        instanceId={instanceId}
        isMulti
        options={options}
        value={selectedOptions}
        onChange={handleChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={false}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        noOptionsMessage={noOptionsMessage}
        components={{ Option, MultiValueRemove, MenuList, DropdownIndicator }}
        classNamePrefix="select-multi"
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  );
}
